import React, { useEffect, useState } from "react";
import { UilCheck } from "@iconscout/react-unicons";
import { useNavigate, useParams } from "react-router-dom";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { ClubeApi } from "../../../hooks/clubeApi";
import AulaCard from "../AulaCard/AulaCard";
import { ContainerTrilha } from "./styles";
import { ClubeTrilha } from "../../../types/Clube";

// Tela "trilha completa": banner da trilha + aulas numa timeline em zigue-zague.
const TrilhaCompleta: React.FC = () => {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const { id } = useParams();
  const clubeApi = ClubeApi();
  const [trilha, setTrilha] = useState<ClubeTrilha | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!id) return;
    clubeApi.registrarEvento("ver_trilha", Number(id));
    clubeApi
      .getTrilha(Number(id))
      .then((res) => setTrilha(res?.trilha || null))
      .finally(() => setLoaded(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (!loaded) return <div style={{ padding: "4rem 10rem" }}>Carregando...</div>;
  if (!trilha)
    return (
      <div style={{ padding: "4rem 10rem" }}>Trilha não encontrada.</div>
    );

  const aulas = trilha.aulas || [];
  const totalAulas = aulas.length;
  const aulasConcluidas = aulas.filter((a) => Number(a.concluida) === 1).length;
  const progresso = totalAulas ? (aulasConcluidas / totalAulas) * 100 : 0;
  const progressoFmt = Math.round(progresso);

  return (
    <ContainerTrilha theme={theme}>
      <div className="banner-trilha">
        {trilha.banner && (
          <img className="capa" src={trilha.banner} alt={trilha.titulo} />
        )}
      </div>

      <div className="trilha-intro">
        <strong className="fonteSubtitulo">{trilha.titulo}</strong>
        {trilha.descricao && (
          <span className="fonteTexto">{trilha.descricao}</span>
        )}
      </div>

      <div className="trilha-progresso">
        <div className="info">
          <span className="rotulo fonteTexto">Progresso</span>
          <span className="pct fonteTexto">{progressoFmt}%</span>
        </div>
        <div className="barra">
          <div className="preenchido" style={{ width: `${progresso}%` }} />
        </div>
      </div>

      <div className="timeline scrollBonito">
        <div className="timeline-inner">
          {(trilha.aulas || []).map((aula, index) => (
            <div
              className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}
              key={aula.id}
            >
              <div
                className={`ponto ${
                  Number(aula.concluida) === 1 ? "concluida" : ""
                }`}
              >
                {Number(aula.concluida) === 1 && (
                  <UilCheck className="check" />
                )}
              </div>
              <AulaCard
                aula={aula}
                onClick={() =>
                  navigate(
                    `/clube-conectado/trilha/${trilha.id}/${encodeURIComponent(
                      trilha.titulo
                    )}/aula/${aula.id}/${encodeURIComponent(aula.titulo)}`
                  )
                }
              />
            </div>
          ))}
        </div>
      </div>
    </ContainerTrilha>
  );
};

export default TrilhaCompleta;
